export const useRule = `공고일자: 2026년 10월 1일 · 시행일자: 2026년 10월 1일
제1장 총칙
제1조 (목적)
이 약관은 기역기역 주식회사(이하 "회사")가 운영하는 라이브커머스 플랫폼 팬버드(Fanbird, 이하 "플랫폼")에서 제공하는 라이브 방송 시청, 셀러 팔로우, 상품 구매 중개 등 관련 서비스(이하 "서비스")를 이용하는 회원과 회사 간의 권리, 의무 및 책임사항을 정함을 목적으로 합니다.
제2조 (용어의 정의)
① "회원(구매자)"이란 이 약관에 동의하고 회사가 정한 절차에 따라 가입하여 서비스를 이용하는 만 14세 이상의 자를 말합니다.
② "셀러(판매자)"란 회사의 셀러 이용약관에 따라 입점 승인을 받아 플랫폼에서 라이브 방송을 진행하고 상품을 판매하는 사업자를 말합니다.
③ "라이브 방송"이란 셀러가 상품 판매를 위해 플랫폼을 통해 실시간으로 송출하는 영상과 이에 연동된 채팅, 상품 정보 등 일체를 말합니다.
④ "팔로우(단골)"란 회원이 특정 셀러를 구독하여 해당 셀러의 라이브 방송 및 상품 정보를 받아보고 구매에 참여하는 기능을 말합니다.
⑤ "셀러 개별약관"이란 셀러가 플랫폼에 등록하여 회원에게 제시하는 해당 셀러의 판매조건(배송, 교환·반품, 환불, 결제수단 등)을 말합니다.
⑥ "PG결제"란 회사가 지정한 전자결제대행사를 통하여 신용카드, 계좌이체, 가상계좌 등으로 대금을 결제하는 방식을 말합니다.
⑦ "무통장 입금"이란 회원이 플랫폼 주문화면에 표시된 셀러 명의의 계좌로 대금을 직접 이체하는 방식을 말합니다.
⑧ "게시물"이란 회원이 서비스에 등록한 채팅, 후기, 문의 등 문자, 이미지, 영상 일체를 말합니다.
제3조 (회사 정보의 표시, 약관의 게시와 개정)
① 회사는 상호, 대표자 성명, 영업소 소재지, 전화번호, 이메일, 사업자등록번호, 통신판매업 신고번호, 개인정보 보호책임자를 플랫폼 초기화면 또는 연결화면에 게시합니다.
② 회사는 「약관의 규제에 관한 법률」, 「전자상거래 등에서의 소비자보호에 관한 법률」(이하 "전자상거래법"), 「개인정보 보호법」 등 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
③ 회사는 약관을 개정하는 경우 적용일자와 개정사유를 명시하여 현행 약관과 함께 적용일자 7일 전부터 공지합니다. 회원에게 불리한 변경은 30일 전부터 공지하고 이메일, 알림톡 등으로 개별 통지하며, 변경 전후 내용을 비교하여 표시합니다.
④ 회사가 제3항에 따라 공지 또는 통지하면서 기간 내 거부 의사를 표시하지 않으면 동의한 것으로 본다는 뜻을 명확히 알렸음에도 회원이 거부 의사를 표시하지 않은 경우, 회원은 개정 약관에 동의한 것으로 봅니다. 동의하지 않는 회원은 이용계약을 해지할 수 있습니다.
제4조 (약관 외 준칙 및 셀러 개별약관과의 관계)
① 이 약관에서 정하지 않은 사항은 전자상거래법, 「약관의 규제에 관한 법률」, 공정거래위원회의 「전자상거래 등에서의 소비자보호지침」 및 관련 법령 또는 상관례에 따릅니다.
② 회원과 셀러 간의 상품 거래에는 셀러 개별약관이 적용되며, 회원은 주문 전 해당 셀러 개별약관을 확인하고 동의하여야 합니다.
③ 셀러 개별약관의 내용이 관련 법령 또는 이 약관보다 회원에게 불리한 경우, 그 불리한 부분은 효력이 없으며 관련 법령 및 이 약관이 적용됩니다.
④ 플랫폼 이용(가입, 계정, 게시물, 이용제한 등)에 관하여는 이 약관이 셀러 개별약관에 우선합니다.
제5조 (회사의 지위)
① 회사는 통신판매중개자로서 회원과 셀러 간 거래를 위한 플랫폼을 제공할 뿐 통신판매의 당사자가 아닙니다. 회사는 이 사실을 상품 정보 및 주문 화면에 표시합니다.
② 상품의 정보, 품질, 배송, 교환·반품·환불 등 거래에 관한 의무와 책임은 해당 셀러에게 있습니다.
③ 회사는 회원이 거래 상대방을 확인할 수 있도록 셀러의 상호, 대표자 성명, 주소, 전화번호, 이메일, 사업자등록번호, 통신판매업 신고번호를 셀러 페이지에 제공합니다.
④ 제1항과 제2항에도 불구하고 회사는 관련 법령에 따라 통신판매중개자가 부담하는 책임을 지며, 회사의 고의 또는 과실로 회원에게 손해가 발생한 경우 이를 배상합니다.
제2장 이용계약
제6조 (이용계약의 성립)
① 이용계약은 가입 신청자가 이 약관과 개인정보 수집·이용에 동의하고 가입을 신청한 후 회사가 이를 승낙함으로써 성립합니다.
② 회사는 카카오 싱크 등 외부 계정을 이용한 간편 가입 및 로그인을 제공합니다.
③ 만 14세 미만의 자는 회원으로 가입할 수 없으며, 회사는 카카오 싱크 가입 화면에서 만 14세 이상임을 확인받습니다.
제7조 (승낙의 거부와 유보)
① 회사는 다음 각 호의 경우 승낙을 거부하거나 사후에 이용계약을 해지할 수 있습니다.
1. 타인의 명의나 정보를 도용하거나 허위 정보를 기재한 경우
2. 이용제한 기간 중 탈퇴 후 재가입하거나, 혜택 부당 취득을 위해 가입·탈퇴를 반복한 경우
3. 만 14세 미만인 경우
4. 그 밖에 관련 법령이나 이 약관을 위반하여 신청한 경우
② 회사는 설비 여유가 없거나 기술상 장애가 있는 경우 승낙을 유보할 수 있으며, 그 사유와 승낙 가능 시기를 신청자에게 알립니다.
제8조 (회원정보와 계정의 관리)
① 회원은 회원정보가 변경된 경우 마이페이지에서 즉시 수정하여야 하며, 수정하지 않아 생긴 불이익은 회원이 부담합니다. 다만 회사의 고의 또는 과실이 있는 경우에는 그러하지 않습니다.
② 회원은 계정을 타인에게 양도하거나 대여할 수 없으며, 도용 사실을 안 경우 즉시 회사에 알려야 합니다.
제9조 (탈퇴 및 자격 상실)
① 회원은 언제든지 마이페이지 또는 고객센터를 통해 탈퇴할 수 있으며, 회사는 즉시 처리합니다. 다만 진행 중인 주문, 교환·반품이 있는 경우 그 처리가 끝난 후 탈퇴가 완료될 수 있습니다.
② 카카오 계정 연결 해제만으로는 회원 탈퇴가 되지 않으므로, 탈퇴를 원하는 회원은 제1항의 절차를 따라야 합니다.
③ 회원이 제21조의 금지행위를 한 경우 회사는 제23조에 따라 이용을 제한하거나 이용계약을 해지할 수 있습니다.
제3장 서비스 이용
제10조 (서비스의 내용)
회사는 다음 각 호의 서비스를 제공합니다.
1. 라이브 방송 및 다시보기 시청, 채팅
2. 셀러 팔로우 및 라이브 시작 알림
3. 상품 주문, 결제 연결, 주문·배송 조회
4. 교환·반품·환불 신청 접수 및 셀러와의 1:1 문의
5. 그 밖에 회사가 정하는 부가 서비스
제11조 (팔로우 및 알림)
① 회원은 셀러를 팔로우하거나 언제든지 팔로우를 해제할 수 있습니다.
② 셀러에게는 팔로우한 회원의 닉네임과 팔로우 여부만 표시되며, 회원의 연락처는 주문이 이루어진 경우에만 개인정보 처리방침에서 정한 범위로 제공됩니다.
③ 라이브 시작 알림, 할인·이벤트 안내 등 영리 목적의 광고성 정보는 회원이 별도로 수신 동의한 경우에만 회사 시스템을 통해 발송합니다. 오후 9시부터 다음 날 오전 8시까지의 발송은 별도 동의를 받은 경우에 한합니다.
④ 회원은 알림 설정 또는 수신거부 링크로 언제든지 수신 동의를 철회할 수 있으며, 회사는 수신 동의를 받은 날부터 2년마다 수신 동의 여부를 회원에게 확인합니다.
⑤ 주문, 결제, 배송, 환불 안내 등 거래 이행에 필요한 정보성 알림은 수신 동의와 관계없이 발송될 수 있습니다.
제12조 (서비스의 변경과 중단)
① 회사는 설비의 보수·점검·교체·고장, 통신 두절, 클라우드 서버 장애 등의 사유로 서비스를 일시 중단할 수 있으며, 사전에 공지합니다. 다만 부득이한 경우 사후에 공지할 수 있습니다.
② 회사는 천재지변 등 불가항력으로 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.
제4장 구매, 결제, 배송
제13조 (매매계약의 체결)
① 매매계약은 회원이 셀러가 제시한 상품 정보와 셀러 개별약관을 확인하고 주문(청약)한 후, 셀러가 이를 승낙함으로써 회원과 셀러 사이에 체결됩니다.
② 회사는 주문 전에 상품의 가격, 배송비, 결제수단, 청약철회 조건, 셀러 신원정보를 회원이 확인할 수 있도록 표시하고, 주문 내용을 확인·정정·취소할 수 있는 절차를 제공합니다.
③ 라이브 방송 중 구두로 안내된 조건이 상품 페이지 또는 셀러 개별약관과 다른 경우, 회원에게 유리한 조건을 적용합니다.
제14조 (결제)
① 결제수단은 셀러가 PG결제와 무통장 입금 중에서 정하며, 주문화면에 표시됩니다.
② PG결제의 경우 회사가 지정한 전자결제대행사(주식회사 헥토파이낸셜)를 통해 결제가 이루어집니다. 회사는 이 결제대금을 받아 셀러에게 정산하며, 전자상거래법에 따라 청약철회에 따른 환급 등 통신판매중개자로서의 책임을 셀러와 함께 부담합니다.
③ 무통장 입금의 경우 대금은 셀러 계좌로 직접 지급되며 회사는 결제대금을 받지 않습니다. 이 경우 다음 각 호가 적용됩니다.
1. 회원은 플랫폼 주문화면에 표시된 셀러 명의의 계좌로만 입금하여야 합니다. 셀러가 채팅, 문자, 전화 등으로 다른 계좌나 외부 결제 링크를 안내하는 경우 응하지 말고 회사에 신고하여 주십시오.
2. 주문화면에 표시된 기한까지 입금하지 않은 주문은 자동 취소될 수 있습니다.
3. 셀러는 관련 법령에 따라 결제대금예치(에스크로) 또는 소비자피해보상보험 등 구매안전서비스를 회원이 선택할 수 있도록 제공하여야 하며, 현금영수증은 셀러가 발급합니다.
4. 환불은 셀러가 회원 계좌로 직접 지급하며, 회사는 환불 지연 시 셀러에게 이행을 요청하고 분쟁조정을 지원합니다.
④ 회원이 입력한 결제정보의 오류로 발생한 손해는 회원이 부담합니다. 다만 회사 또는 셀러의 고의 또는 과실이 있는 경우에는 그러하지 않습니다.
제14조의2 (가상계좌 결제와 환불)
① 가상계좌의 사용 목적: 가상계좌는 회원이 플랫폼의 라이브커머스 방송 및 상품 페이지에서 주문한 상품의 대금을 결제하기 위한 용도로만 발급되며, 상품 대금 결제 외의 송금, 자금 이전, 적립 등 다른 목적으로 사용할 수 없습니다.
② 발급과 입금: 가상계좌는 회사가 지정한 전자결제대행사(주식회사 헥토파이낸셜)를 통해 주문 1건마다 회원에게 발급되며, 회원은 주문화면에 표시된 입금기한 내에 주문 금액과 같은 금액을 입금하여야 합니다. 입금기한이 지나면 해당 가상계좌는 소멸하고 주문은 자동 취소됩니다.
③ 결제 완료: 입금이 확인된 때에 결제가 완료되며, 회사는 결제 완료 사실을 회원에게 알립니다. 주문 금액과 다른 금액을 입금한 경우 입금이 거절되거나 결제가 완료되지 않을 수 있습니다.
④ 가상계좌 환불 정책: 가상계좌로 결제한 대금은 다음 각 호에 따라 회원 본인 명의의 환불계좌로 환불합니다.
1. 상품 발송 전 주문 취소: 취소 확인일부터 3영업일 이내
2. 청약철회(교환 불가로 인한 반품 포함): 셀러가 반품 상품을 돌려받은 날부터 3영업일 이내
3. 품절, 셀러 사정 등으로 주문이 취소된 경우: 취소일부터 3영업일 이내
4. 이중입금, 초과입금 등 착오 입금: 회원의 요청 또는 회사의 확인일부터 3영업일 이내
⑤ 환불계좌: 회원은 환불 신청 시 본인 명의 계좌를 등록하여야 하며, 회사는 예금주 확인 후 환불합니다. 회원이 계좌를 등록하지 않거나 잘못 등록하여 환불이 늦어진 기간은 환불 기한에 포함하지 않습니다.
⑥ 환불 비용: 가상계좌 환불에 드는 송금 수수료는 회사가 부담합니다. 다만 단순 변심 반품의 반품 배송비는 제16조 제4항에 따라 회원이 부담하며, 환불 금액에서 공제할 수 있습니다.
⑦ 부분 환불: 여러 상품 중 일부만 취소·반품한 경우 해당 상품 금액(배송비 조건이 바뀌는 경우 그 차액 반영)만 환불합니다.
⑧ 회사 또는 셀러가 정해진 기한 내에 환불하지 않은 경우, 지연된 기간에 대하여 전자상거래법에서 정한 지연배상금을 함께 지급합니다.
제15조 (배송)
① 셀러는 대금 결제(무통장 입금은 입금 확인)일부터 7일 이내에 상품을 발송하여야 하며, 이를 넘기는 경우 사전에 그 사유와 예정일을 회원에게 알려야 합니다.
② 회사는 셀러가 입력한 송장번호를 바탕으로 배송 조회 및 배송 단계 알림을 제공할 수 있습니다.
③ 천재지변 등 불가항력 기간은 배송 소요기간에서 제외됩니다.
제16조 (청약철회 등)
① 회원은 상품을 공급받은 날(계약서면을 받은 날이 더 늦은 경우 그날)부터 7일 이내에 청약철회(교환·반품)를 할 수 있습니다.
② 상품이 표시·광고 내용과 다르거나 계약 내용과 다르게 이행된 경우, 회원은 상품을 공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회를 할 수 있습니다.
③ 다음 각 호의 경우에는 청약철회가 제한될 수 있습니다. 다만 제2호부터 제4호까지는 셀러가 그 사실을 상품 페이지 등에 명확히 표시하거나 시용상품을 제공하는 등의 조치를 한 경우에 한합니다.
1. 회원의 책임 있는 사유로 상품이 멸실·훼손된 경우(내용 확인을 위한 포장 훼손은 제외)
2. 회원의 사용 또는 일부 소비로 상품의 가치가 현저히 감소한 경우
3. 시간이 지나 다시 판매하기 곤란할 정도로 상품의 가치가 현저히 감소한 경우(신선·냉장·냉동식품 등)
4. 복제가 가능한 상품의 포장을 훼손한 경우
5. 주문에 따라 개별 생산되는 상품으로서 사전에 그 사실을 고지하고 회원의 서면(전자문서 포함) 동의를 받은 경우
④ 단순 변심에 의한 반품 비용은 회원이, 하자·오배송 등 셀러 사유에 의한 비용은 셀러가 부담합니다.
⑤ 교환 신청 시 셀러에게 재고가 없는 경우 반품으로 처리됩니다.
제17조 (청약철회의 효과와 환급)
① 셀러는 반품된 상품을 돌려받은 날부터 3영업일 이내에 대금을 환급하여야 하며, 환급이 지연되는 경우 지연기간에 대하여 관련 법령에서 정한 지연배상금을 지급합니다.
② 신용카드 등으로 결제된 경우 회사는 셀러의 환급 승인 또는 반품 확인 후 지체 없이 결제업자에게 대금 청구의 정지 또는 취소를 요청합니다.
③ 상품 발송 전 취소는 셀러의 확인 후 즉시 처리되며, 환급 기한은 제1항을 따릅니다.
제18조 (분쟁 처리)
① 회사는 고객센터를 운영하여 회원의 불만과 셀러와의 분쟁을 접수하고, 필요한 경우 셀러에게 사실 확인과 조치를 요청합니다.
② 회사는 분쟁 해결을 위해 소비자분쟁조정위원회, 전자거래분쟁조정위원회 등에 피해구제 신청을 안내·대행할 수 있으며, 관계기관의 적법한 요청이 있으면 셀러 정보를 제공합니다.
제5장 의무와 이용제한
제19조 (회사의 의무)
① 회사는 관련 법령과 이 약관이 금지하는 행위를 하지 않으며, 안정적으로 서비스를 제공하기 위해 노력합니다.
② 회사는 회원의 개인정보를 개인정보 처리방침에 따라 보호합니다.
제20조 (게시물)
① 게시물의 저작권은 작성한 회원에게 있으며, 회사는 서비스 운영과 홍보에 필요한 범위에서 게시물을 무상으로 이용할 수 있습니다. 회원이 삭제 또는 이용 중지를 요청하면 회사는 법령상 보존 의무가 있는 경우를 제외하고 지체 없이 따릅니다.
② 회사는 게시물이 법령 위반, 타인 권리 침해, 음란·비방, 외부 거래 유도 등에 해당하는 경우 삭제하거나 노출을 제한할 수 있습니다. 다만 상품에 대한 정당한 불만이라는 이유만으로 게시물을 삭제하지 않습니다.
제21조 (회원의 금지행위)
회원은 다음 각 호의 행위를 하여서는 안 됩니다.
1. 타인 정보 도용, 허위 정보 등록
2. 구매 의사 없는 반복 주문·취소, 혜택 부당 취득, 재판매 목적의 부정 구매
3. 셀러와의 직거래 또는 플랫폼 외부 거래 유도
4. 라이브 채팅에서 음란, 욕설, 비방, 도배, 허위사실 유포
5. 회사, 셀러, 제3자의 지식재산권 침해 및 방송 영상의 무단 녹화·배포
6. 비정상적인 방법으로 시스템에 접근하거나 서비스 운영을 방해하는 행위
7. 회사 임직원이나 셀러를 사칭하는 행위
제22조 (회원 정보의 셀러 제공)
주문이 이루어지면 회사는 배송과 교환·반품·고객상담에 필요한 최소한의 정보를 해당 셀러에게 제공합니다. 셀러는 이를 그 목적 외로 이용할 수 없으며, 회원은 셀러의 목적 외 연락이나 외부 채널 홍보를 회사에 신고할 수 있습니다.
제23조 (이용제한)
① 회사는 회원이 제21조를 위반한 경우 경고, 일시 이용정지, 혜택 회수, 이용계약 해지 등의 조치를 할 수 있습니다.
② 회사는 조치 전에 그 사유를 회원에게 알리고 소명 기회를 주며, 긴급한 경우 먼저 조치한 후 알릴 수 있습니다. 회원은 조치에 이의를 제기할 수 있습니다.
제6장 기타
제24조 (손해배상 및 책임의 제한)
① 회사 또는 회원이 이 약관을 위반하여 상대방에게 손해를 입힌 경우 그 손해를 배상합니다.
② 회사는 다음 각 호의 경우 책임을 지지 않습니다. 다만 회사의 고의 또는 과실이 있는 경우에는 그러하지 않습니다.
1. 천재지변 등 불가항력에 의한 서비스 장애
2. 회원의 귀책사유로 인한 서비스 이용 장애
3. 회원과 셀러 간 거래에서 셀러의 귀책사유로 발생한 손해(회사가 법령상 함께 책임지는 경우는 제외)
제25조 (통지)
회사는 회원에게 이메일, 알림톡, 휴대전화번호 등으로 개별 통지하며, 불특정 다수 회원에 대한 통지는 7일 이상 공지사항 게시로 갈음할 수 있습니다. 다만 회원의 거래에 중대한 영향을 미치는 사항은 개별 통지합니다.
제26조 (준거법 및 관할)
이 약관과 서비스 이용에 관한 분쟁에는 대한민국 법률을 적용하며, 소송은 「민사소송법」에 따른 관할법원에 제기합니다.
부칙
이 약관은 2026년 10월 1일부터 시행합니다.
사업자 정보
• 상호: 기역기역 주식회사 / 대표자: 이헌영
• 사업자등록번호: 669-87-03262
• 주소: 전남광주통합특별시 동구 필문대로 287번길 3
• 전화: 0507-1336-7115 / 이메일: linkcampus01@gmail.com`;
